import { GenericSuspense, useRuntimeEnv, useTranslationRoute, useUrlParamsEncode, useUrlParamsValue } from "@bsm/component";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";

const OrganisationAccessLayer = () => {
    const { runtimeEnv } = useRuntimeEnv();
    const isAuthenticated = runtimeEnv?.authenticated;
    const isAdmin = runtimeEnv?.user?.canManageUser as any;
    const location = useLocation();
    const urlEncode = useUrlParamsEncode();
    const urlParams = useUrlParamsValue()
    const organisation = runtimeEnv?.organisation;
    const navigate = useNavigate();
    const t = useTranslationRoute();

    useEffect(() => {
        isAuthenticated && organisation !== null && isAdmin && navigate(t(`admin${location.pathname.split("/admin")[1] ?? ''}${urlParams ? '?' + urlEncode(urlParams) : ''}`));
        isAuthenticated && organisation !== null && !isAdmin && navigate(t(`user${location.pathname.split("/user")[1] ?? ''}${urlParams ? '?' + urlEncode(urlParams) : ''}`));
        isAuthenticated && organisation === null && navigate(t(""));
    }, []);

    return (
        <>
            <GenericSuspense>
                <Outlet />
            </GenericSuspense>
        </>
    );
};
export default OrganisationAccessLayer;
